import { NotificationMessageAiResponse } from '@aimi/models';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import {
  ChatConversationAddMessage,
  ChatConversationUpdateMessage,
} from '../chat/chat-conversation/chat-conversation.action';
import {
  ApplicationContainer,
  UtilityService,
} from '../../core/utility.service';
import { delay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SocketIoMessageHandlerService {
  #store = inject(Store);
  #utilityService = inject(UtilityService);

  handleGeminiResponse(payloadData: NotificationMessageAiResponse) {
    this.#store
      .dispatch(new ChatConversationAddMessage(payloadData.message))
      .pipe(delay(200))
      .subscribe(() => {
        this.#utilityService.scrollToBottom(
          ApplicationContainer.CHAT_CONVERSATION,
        );
      });
  }

  handleGeminiResponseUpdate(payloadData: NotificationMessageAiResponse) {
    this.#store
      .dispatch(new ChatConversationUpdateMessage(payloadData.message))
      .pipe(delay(200))
      .subscribe(() => {
        this.#utilityService.scrollToBottom(
          ApplicationContainer.CHAT_CONVERSATION,
        );
      });
  }
}
